import BaseReducer from "./BaseReducer";
import {
  anHourFromNow,
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "@common/components/helpers/datetime";

class ObservationsReducer extends BaseReducer {
  domain = "Observations";
  type = "View";

  initialState = {
    observationDate: getDatePart(getCurrentDateTime()),
    observationTime: getTimePart(getCurrentDateTime()),

    customerUnknown: false,
    // For form input field display purpose
    searchedCustomer: null,
    // The actual selected customer
    customer: null,

    observation: null,
    customerMood: [],
    comments: "",
    setReminder: null,
    reminderDate: getDatePart(anHourFromNow()),
    reminderTime: getTimePart(anHourFromNow()),

    observationOptions: [],
    moodOptions: [],
    record: null,
    customerRecord: null,

    // Compliance Alerts and Linked Sessions
    complianceAlertId: null,
  };
}

const reducer = new ObservationsReducer();

export default reducer;
